import * as React from 'react';
import classnames from 'classnames';

import type { TabsUnderlinedItem } from 'types';

type Props = {
  items: Array<TabsUnderlinedItem>,
  size: 'small' | 'normal' | 'inherit',
  tabClassName?: string,
  toggleIdsMap?: {
    [type: number]: boolean | string
  }
};

class TabsUnderlined extends React.PureComponent<Props> {
  static defaultProps = {
    items: [],
    size: 'normal'
  };

  getActiveState = () => {
    const { toggleIdsMap } = this.props;

    if (!toggleIdsMap || Object.keys(toggleIdsMap).length === 0) {
      return null;
    }

    const valueOfAnyItem = toggleIdsMap[Object.keys(toggleIdsMap)[0]];

    return Object.keys(toggleIdsMap)
      .filter(key => toggleIdsMap[key] !== valueOfAnyItem).length === 0 ? valueOfAnyItem : null;
  };

  render(): React.ReactNode {
    const { items, size, tabClassName } = this.props;
    const activeState = this.getActiveState();

    if (items.length === 0) {
      return null;
    }

    const containerClasses = classnames({
      'tabs-underlined': true,
      [`tabs-underlined--size-${size}`]: size
    });

    return (
      <ul className={containerClasses}>
        {
          items.map((item, index) => {
            const { handleClick, handleClickArg, label, isActive } = item;

            const tabClasses = classnames('tabs-underlined__tab', tabClassName, {
              'tabs-underlined__tab--active': (activeState === handleClickArg) || Boolean(isActive)
            });

            return (
              <li
                key={`tabs-underlined__tab--${index}`}
                className={tabClasses}
                onClick={handleClick}
                data-arg={handleClickArg}
              >
                <span>{label}</span>
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default TabsUnderlined;
